import { WagmiProvider, createConfig, http } from "wagmi";
import { mainnet } from "wagmi/chains";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import WalletButton from "./WalletButton";

const wagmiConfig = createConfig({
  chains: [mainnet],
  transports: { [mainnet.id]: http() },
});
const queryClient = new QueryClient();

interface Tier {
  name: string;
  capacity: string;
  price: string;
  highlight?: boolean;
}

const TIERS: Tier[] = [
  { name: "starter", capacity: "10 TB equivalent", price: "$99.99" },
  { name: "pro", capacity: "100 TB equivalent", price: "$399.99" },
  { name: "vault", capacity: "350 TB equivalent", price: "$999.99", highlight: true },
];

function Card({ tier }: { tier: Tier }) {
  return (
    <div
      className={
        "border rounded p-6 flex flex-col gap-4 " +
        (tier.highlight ? "border-white bg-white/5" : "border-white/20")
      }
    >
      <div className="font-mono text-sm uppercase tracking-widest opacity-60">
        {tier.name}
      </div>
      <div className="text-3xl font-mono">{tier.price}</div>
      <div className="text-sm opacity-80">{tier.capacity}</div>
      <div className="text-xs opacity-60">one-time payment, lifetime pinning</div>
      <div className="mt-auto pt-4">
        <WalletButton />
      </div>
    </div>
  );
}

export default function Pricing() {
  return (
    <WagmiProvider config={wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        <div className="max-w-5xl mx-auto p-6 space-y-6">
          <header>
            <h1 className="text-2xl font-mono">pricing</h1>
            <p className="opacity-70 text-sm mt-1">
              LLM compression turns commodity IPFS pinning into terabyte-scale
              storage. Pay once, store forever.
            </p>
          </header>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {TIERS.map((t) => (
              <Card key={t.name} tier={t} />
            ))}
          </div>
          <p className="text-xs opacity-50 font-mono">
            wallet button is decorative; payments are not enabled in the demo.
          </p>
        </div>
      </QueryClientProvider>
    </WagmiProvider>
  );
}
